<template>
  <el-row type="flex" justify="space-between">
    <el-col :span="20">
      <el-input
        :readonly="true"
        style="width:100%"
        placeholder="图片支持jpeg、jpg、png格式，大小5M内"
        v-model="picData.picName">
      </el-input>
    </el-col>
    <el-col :span="4">
          <el-upload
            :data="imgParams"
            ref="upload"
            name="file"
            action="/api/paas-platform/file-service/v1/file/upload/fileUpload"
            accept="image/jpg,image/jpeg,image/png"
            :before-upload="beforeUp"
            :on-success="handleAvatarSuccess"
            :show-file-list="false"
            :before-remove="handleRemove"
            :on-change="handleChange"
            :auto-upload="true"
            :file-list="picData.appGuideSubVoList">
          <el-button icon="el-icon-upload2">上传文件</el-button>
      </el-upload>
    </el-col>
  </el-row>
</template>
<script>
export default {
  props: {
    index: {
      type: Number
    },
    uploadFileList: {
      type: Array
    },
    picData: {
      type: Object
    }
  },
  data () {
    return {
      imgParams: {
        dir: 'appGuide/img'
      },
      fileList: []
    }
  },
  mounted() {
    let x = this.picData;
    debugger;
  },
  methods: {
    /* remove () {
      this.uploadFileList.splice(this.index, 1)
    }, */
    handleChange (selFile, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      this.fileList = fileList
    },
    handleRemove () {
      this.fileList.splice(0)
    },
    handleAvatarSuccess (res, file) {
      if (res.code !== 200) {
        this.$message.error('上传出错，请重新上传')
      } else {
        console.log('name', file.name)
        console.log('fileUrl', res.data.fileUrl)
        console.log('fileKey', res.data.pathKey)
        const obj = {}
        obj.name = file.name
        obj.fileUrl = res.data.fileUrl
        obj.fileKey = res.data.pathKey
        this.picData.picName = file.name
        this.$emit('getData', obj)
      }
    },
    beforeUp (file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
        this.$message.error('上传文件只能是图片格式！')
        return false
      }
      if (file.size / 1024 / 1024 >= 5) {
        this.$message.error('请上传5M以内的图片！')
        return false
      }
      return true
    }
  }
}
</script>
<style lang='less' scoped>
.avatar-uploader-icon {
     font-size: 14px;
    color:white;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color:#409EFF;
    border-radius: 25px;
    cursor: pointer;
  }
  .el-button{
    margin-left: 10px;
  }
  .el-icon-delete-solid{
    font-size: 20px;
    cursor: pointer;
  }
</style>
